import './host'

import { RegionalUserData, RegionalUserService } from '@graft/nuget-gc.webportals.regionalusers'

import { getSessionToken } from '@common/core/helpers'
import { isVisionLocal } from '@common/core/utils/isVisionLocal'
import { withTiming } from '@common/core/utils/withTiming'

import { regionalUserToObject } from './objects/regional-user.object'
import { RegionalUser } from './types/user.type'

export async function addUserRegionalData(regionalUser: RegionalUser): Promise<string | null> {
  try {
    if (isVisionLocal() || !regionalUser) return null

    const { id, email, firstname, lastname } = regionalUser
    const regionalUserData = new RegionalUserData(id, email, firstname, lastname)

    const token = await getSessionToken()
    return RegionalUserService.addUserRegionalData(token, regionalUserData)
  } catch (error) {
    console.error('Failed to add user regional data:', error)
    throw error
  }
}

export async function getUserRegionalData(): Promise<RegionalUser | null> {
  try {
    if (isVisionLocal()) return null

    const token = await getSessionToken()
    const graftcodeData = await withTiming('getUserRegionalData', async () =>
      RegionalUserService.getUserRegionalData(token)
    )()

    return graftcodeData ? await regionalUserToObject(graftcodeData) : null
  } catch (error) {
    console.error('Failed to get user regional data:', error)
    return null
  }
}

export async function updateUserNames(firstName: string, lastName: string): Promise<void> {
  if (isVisionLocal()) return

  try {
    const token = await getSessionToken()
    await RegionalUserService.updateUserNames(token, firstName, lastName)
  } catch (error) {
    console.error('Failed to update regional user names:', error)
    throw error
  }
}

export async function updateUserEmail(userEmail: string): Promise<void> {
  if (isVisionLocal()) return

  try {
    const token = await getSessionToken()
    await RegionalUserService.updateUserEmail(token, userEmail)
  } catch (error) {
    console.error('Failed to update regional user email:', error)
    throw error
  }
}

export async function updateUserAvatar(avatar: number[]): Promise<void> {
  if (isVisionLocal()) return

  try {
    const token = await getSessionToken()
    await RegionalUserService.updateUserAvatar(token, avatar)
  } catch (error) {
    console.error('Failed to update regional user avatar:', error)
    throw error
  }
}
